import { Fragment } from 'react';

import * as S from './style';

type ThreeColumnRow = {
	name: string;
	org: string;
	role: string;
};

type FourColumnRow = {
	name: string;
	org: string;
	part: string;
	role: string;
};

const honoraryPresidents = [
	{ name: '구용섭', term: '1968. 10. 15 ~ 1982. 05. 19' },
	{ name: '오원식', term: '1982. 05. 20 ~ 1991. 10. 30' },
	{ name: '(故)김창규', term: '1991. 10. 31 ~ 2006. 03. 02' },
	{ name: '이옥섭', term: '2006. 03. 03 ~ 2013. 03. 29' },
	{ name: '박수남', term: '2013. 03. 30 ~ 2017. 05. 26' },
	{ name: '강학희', term: '2017. 05. 27 ~ 2019. 05. 31' },
	{ name: '조완구', term: '2019. 06. 01 ~ 2021. 12. 31' },
	{ name: '박영호', term: '2022. 01. 01 ~ 2024. 12. 31' },
];

const registeredExecutives: ThreeColumnRow[] = [
	{ role: '회장', name: '황재성', org: '경희대학교' },
	{ role: '부회장', name: '강승현', org: '코스맥스' },
	{ role: '부회장', name: '서병휘', org: '아모레퍼시픽' },
	{ role: '부회장', name: '한상근', org: '한국콜마㈜' },
	{ role: '운영위원장', name: '박성일', org: '아모레퍼시픽' },
	{ role: '학술위원장', name: '신동욱', org: '건국대학교' },
	{ role: '국제홍보위원장', name: '이성호', org: '선진뷰티사이언스' },
	{ role: '편집위원장', name: '박준성', org: '충북대학교' },
	{ role: '산학협력위원장', name: '박진오', org: '대봉LS㈜' },
	{ role: '감사', name: '조윤기', org: '엑티브온' },
	{ role: '감사', name: '박재홍', org: '더케이뷰티사이언스' },
	{ role: '이사', name: '김진웅', org: '성균관대학교' },
	{ role: '이사', name: '손남서', org: 'LG생활건강' },
];

const associateCouncilors: ThreeColumnRow[] = [
	{ role: '평의원', name: '강내규', org: 'LG생활건강' },
	{ role: '평의원', name: '강병영', org: '아모레퍼시픽' },
	{ role: '평의원', name: '강희철', org: '지에프씨생명과학' },
	{ role: '평의원', name: '고재숙', org: '더마프로' },
	{ role: '평의원', name: '김진화', org: '잇츠한불' },
	{ role: '평의원', name: '박덕훈', org: '바이오스펙트럼' },
	{ role: '평의원', name: '박명삼', org: '코스맥스' },
	{ role: '평의원', name: '박원석', org: '아모레퍼시픽' },
	{ role: '평의원', name: '박천호', org: '코스맥스 BTI' },
	{ role: '평의원', name: '변경수', org: '엘리드' },
	{ role: '평의원', name: '신계호', org: '수원과학대학교' },
	{ role: '평의원', name: '신대현', org: '코스모코스' },
	{ role: '평의원', name: '양창준', org: '아이엠씨디코이라 주식회사' },
	{ role: '평의원', name: '연재호', org: '대한화장품협회' },
	{ role: '평의원', name: '이근수', org: '코씨드바이오팜' },
	{ role: '평의원', name: '이정표', org: '(재)대한화장품산업연구원' },
	{ role: '평의원', name: '이희준', org: '현대바이오랜드' },
	{ role: '평의원', name: '장민열', org: '스킨메드 임상시헌센터' },
	{ role: '평의원', name: '조준철', org: '제너럴비에이치' },
	{ role: '평의원', name: '조해', org: '한국암웨이' },
	{ role: '평의원', name: '최영진', org: '코스메카코리아' },
];

const editorialDirectors: ThreeColumnRow[] = [
	{ role: '편집이사', name: '김수남', org: '한국과학기술연구원' },
	{ role: '편집이사', name: '김혁', org: '아모레퍼시픽' },
	{ role: '편집이사', name: '남개원', org: '연세대학교' },
	{ role: '편집이사', name: '박청', org: '前 대전대학교' },
	{ role: '편집이사', name: '안수미', org: '인비보텍' },
	{ role: '편집이사', name: '이준배', org: '코스맥스' },
	{ role: '편집이사', name: '이창석', org: '을지대학교' },
];

const committeeMembers: FourColumnRow[] = [
	{ part: '소재', role: '위원장', name: '신송석', org: '현대바이오랜드' },
	{ part: '소재', role: '부위원장', name: '노호식', org: '수원대학교' },
	{ part: '소재', role: '부위원장', name: '신경희', org: '선진뷰티사이언스' },
	{ part: '피부 & 천연물 효능기전', role: '위원장', name: '박병준', org: '한국콜마' },
	{ part: '피부 & 천연물 효능기전', role: '부위원장', name: '정의택', org: 'LG생활건강' },
	{ part: '피부 & 천연물 효능기전', role: '부위원장', name: '모상현', org: 'BIOFD&C' },
	{ part: '제형', role: '위원장', name: '홍인기', org: '한국콜마' },
	{ part: '제형', role: '부위원장', name: '김문주', org: 'LG생활건강' },
	{ part: '제형', role: '부위원장', name: '이진현', org: '건국대학교' },
	{ part: '평가 및 임상', role: '위원장', name: '이해광', org: 'P&K피부임상연구센타' },
	{ part: '평가 및 임상', role: '부위원장', name: '하재현', org: '아이이씨코리아' },
	{ part: '안전성', role: '위원장', name: '백지훈', org: '휴먼 임상시험센터' },
	{ part: '안전성', role: '부위원장', name: '김민서', org: '한국콜마' },
	{ part: '안전성', role: '부위원장', name: '안수선', org: '(주)크리스아이' },
	{ part: '대체법', role: '위원장', name: '임경민', org: '이화여자대학교' },
	{ part: '대체법', role: '부위원장', name: '김서영', org: '아모레퍼시픽' },
	{ part: '제도', role: '위원장', name: '김지연', org: '식품의약품안전처' },
	{ part: 'AI', role: '위원장', name: '김현정', org: '가천대학교 길병원' },
	{ part: 'AI', role: '부위원장', name: '남개원', org: '연세대학교' },
];

const getGroupedRowSpan = <T,>(rows: T[], keyGetter: (row: T) => string) =>
	rows.map((row, index) => {
		const key = keyGetter(row);
		if (index > 0 && keyGetter(rows[index - 1]) === key) return 0;
		let span = 1;
		for (let cursor = index + 1; cursor < rows.length; cursor += 1) {
			if (keyGetter(rows[cursor]) !== key) break;
			span += 1;
		}
		return span;
	});

const renderThreeColumnTable = (rows: ThreeColumnRow[]) => {
	const rowSpans = getGroupedRowSpan(rows, (row) => row.role);

	return (
		<S.Table>
			<S.TableHeadCell className="center">직책</S.TableHeadCell>
			<S.TableHeadCell className="center">성명</S.TableHeadCell>
			<S.TableHeadCell className="center">소속</S.TableHeadCell>
			{rows.map((row, index) => (
				<Fragment key={`${row.role}-${row.name}-${row.org}`}>
					{rowSpans[index] > 0 && (
						<S.TableCell className="point min-height center" style={{ gridRow: `span ${rowSpans[index]}` }}>
							{row.role}
						</S.TableCell>
					)}
					<S.TableCell className="center">{row.name}</S.TableCell>
					<S.TableCell className="center">{row.org}</S.TableCell>
				</Fragment>
			))}
		</S.Table>
	);
};

const renderCommitteeTable = (rows: FourColumnRow[]) => {
	const rowSpans = getGroupedRowSpan(rows, (row) => row.part);

	return (
		<S.FourColumnTable>
			<S.TableHeadCell className="center">분과명</S.TableHeadCell>
			<S.TableHeadCell className="center">직책</S.TableHeadCell>
			<S.TableHeadCell className="center">이름</S.TableHeadCell>
			<S.TableHeadCell className="center">소속기관</S.TableHeadCell>
			{rows.map((row, index) => (
				<Fragment key={`${row.part}-${row.role}-${row.name}-${row.org}`}>
					{rowSpans[index] > 0 && (
						<S.TableCell className="point min-height center" style={{ gridRow: `span ${rowSpans[index]}` }}>
							{row.part}
						</S.TableCell>
					)}
					<S.TableCell className="center">{row.role}</S.TableCell>
					<S.TableCell className="center">{row.name}</S.TableCell>
					<S.TableCell className="center">{row.org}</S.TableCell>
				</Fragment>
			))}
		</S.FourColumnTable>
	);
};

const ExecutiveList = () => (
	<S.ExecutiveListContainer>
		<S.ExecutiveListItemContainer>
			<S.ExecutiveListTitle>명예회장</S.ExecutiveListTitle>
			<S.Table>
				<S.TableHeadCell className="center">직책</S.TableHeadCell>
				<S.TableHeadCell className="center">성명</S.TableHeadCell>
				<S.TableHeadCell className="center">재임기간</S.TableHeadCell>
				<S.TableCell className="point min-height center" style={{ gridRow: `span ${honoraryPresidents.length}` }}>
					명예회장
				</S.TableCell>
				{honoraryPresidents.map((president) => (
					<Fragment key={`honorary-${president.name}`}>
						<S.TableCell className="center">{president.name}</S.TableCell>
						<S.TableCell className="center">{president.term}</S.TableCell>
					</Fragment>
				))}
			</S.Table>
		</S.ExecutiveListItemContainer>

		<S.ExecutiveListItemContainer>
			<S.ExecutiveListTitle>등기임원</S.ExecutiveListTitle>
			{renderThreeColumnTable(registeredExecutives)}
		</S.ExecutiveListItemContainer>

		<S.ExecutiveListItemContainer>
			<S.ExecutiveListTitle>평의원</S.ExecutiveListTitle>
			{renderThreeColumnTable(associateCouncilors)}
			<S.ExecutiveListTitle>평의원(편집위원회(편집이사) 겸직)</S.ExecutiveListTitle>
			{renderThreeColumnTable(editorialDirectors)}
			<S.ExecutiveListTitle>평의원(학술위원회(분과위원회) 겸직)</S.ExecutiveListTitle>
			{renderCommitteeTable(committeeMembers)}
		</S.ExecutiveListItemContainer>
	</S.ExecutiveListContainer>
);

export default ExecutiveList;
